import Vue from 'vue';
import { userLog } from 'Api/user';
import CONFIG from 'Config';

function setHandlers() {
  Vue.config.errorHandler = function vueErrorHandler(error, vm, info) {
    try {
      userLog('error-on-vue', {
        error: error.toString(),
        component: vm && vm.$options && vm.$options.name,
        info,
      });
    } catch (e) {
      // do nothing on error
    }
    // throw error to see in console
    throw error;
  };

  window.onerror = function windowErrorHandler(error, url, lineNumber) {
    try {
      userLog('error-on-window', {
        error: error.toString ? error.toString() : error,
        url,
        lineNumber,
      });
    } catch (e) {
      // ignore any errors
    }
    // throw error to see in console
    throw error;
  };
}

// Set handlers only if not dev environment
if (!CONFIG.isEnvDev) setHandlers();
